import { format, parseISO } from "date-fns";

export function formatMoney(v) {
    if (v === null || v === undefined || Number.isNaN(v)) return "$0";
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(v);
}

export function safeParse(iso) {
    try {
        return typeof iso === "string" ? parseISO(iso) : new Date(iso);
    } catch {
        return new Date(iso);
    }
}

export function fmtDateTime(iso, fmt = "MMM d, h:mm a") {
    if (!iso) return "";
    try {
        return format(safeParse(iso), fmt);
    } catch {
        return iso;
    }
}

export function fmtDate(iso, fmt = "MMM d, yyyy") {
    return fmtDateTime(iso, fmt);
}

export function fmtTime(iso, fmt = "h:mm a") {
    return fmtDateTime(iso, fmt);
}

export function durationHours(startIso, endIso) {
    try {
        return ((safeParse(endIso) - safeParse(startIso)) / 1000 / 3600).toFixed(1);
    } catch {
        return "";
    }
}

export function initials(name) {
    if (!name) return "?";
    return name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
}
